<!--  -->
<template>
	<div class="drawer-wrapper">
		<el-drawer size="50%" :wrapperClosable="true" title="编辑" :visible.sync="AddFlag" :before-close="handleClose">
			<div class="demo-drawer__content">
				<el-form :model="addFrom" size="medium" class="mt35" :rules="rules" ref="ruleForm">
					<el-row :gutter="35" class="center-content">
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="推广链接名称" :label-width="formLabelWidth">
								<el-input v-model="addFrom.channel_name" placeholder="请输入推广链接名称" clearable
									style="width: 90%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="免费章节数" :label-width="formLabelWidth">
								<el-input v-model="addFrom.o_free_chapter" placeholder="请输入推广链接名称" clearable
									style="width: 90%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="单章价格" :label-width="formLabelWidth">
								<el-input v-model="addFrom.o_chapter_price" placeholder="请输入推广链接名称" clearable
									style="width: 90%;"></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="充值模版" prop="recharge_template_id" :label-width="formLabelWidth">
								<div style="display: flex">
									<el-select v-model="addFrom.recharge_template_id" placeholder="请选择充值模版" clearable
										style="width: 90%;">
										<el-option v-for="dict in Recharge" :key="dict.id" :label="dict.value"
											:value="dict.id" />
									</el-select>
									<!-- <el-button type="primary" @click="Look">查看</el-button> -->
								</div>

							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="回传规则" prop="recharge_template_id" :label-width="formLabelWidth">
								<el-select v-model="addFrom.ad_id" placeholder="请选择回传规则" clearable style="width: 90%;">
									<el-option v-for="dict in RechargeRule" :key="dict.id" :label="dict.title"
										:value="dict.id" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="switch_btn == 1">
							<el-form-item label="单集价格" prop="o_chapter_price" :label-width="formLabelWidth">
								<div class="input-with-pcenter" style="display: flex">
									<el-input v-model.number="addFrom.o_chapter_price" placeholder="请输入单集价格" clearable
										style="width: 50%"></el-input>
									<p class="pcenter" style="margin-left: 20px; color: red">
										单集价格范围{{ chapter.chapter_priceone }}-{{ chapter.chapter_pricetwo }}
									</p>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="switch_btn == 1">
							<el-form-item label="免费集数" prop="o_free_chapter" :label-width="formLabelWidth">
								<div class="input-with-pcenter" style="display: flex">
									<el-input v-model.number="addFrom.o_free_chapter" placeholder="请输入免费集数" clearable
										style="width: 50%"></el-input>
									<p class="pcenter" style="margin-left: 20px; color: red">
										免费集数范围{{ chapter.free_chapteroneone }}-{{ chapter.free_chaptertwo }}
									</p>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="负责人" prop="owner" :label-width="formLabelWidth">
								<el-input v-model="addFrom.owner" placeholder="请输入负责人" style="width: 90%;"
									clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="状态" prop="status" :label-width="formLabelWidth">
								<el-radio-group v-model="addFrom.status">
									<el-radio :label="1">有效</el-radio>
									<el-radio :label="3">停止投放</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>

			<div class="demo-drawer__footer">
				<el-button @click="AddNone">取 消</el-button>
				<el-button type="primary" @click="addPush">确 定</el-button>
			</div>
			<el-dialog :close-on-click-modal="false" width="60%" title="充值模版" :visible.sync="LookVisible" append-to-body
				:before-close="handleCloseLook">
				<div>
					<el-table ref="multipleTable" :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
						:cell-style="{ textAlign: 'center' }" :data="tableData"
						@selection-change="handleSelectionChange" border>
						<el-table-column label="ID">
							<template slot-scope="scope">{{ scope.row.id }}</template>
						</el-table-column>
						<el-table-column label="模版说明">
							<template slot-scope="scope">{{ scope.row.name }}</template>
						</el-table-column>
						<el-table-column label="充值状态">
							<template slot-scope="scope">
								<span v-if="scope.row.is_open == 0">不区分</span>
								<span v-if="scope.row.is_open == 1">区分</span>
							</template>
						</el-table-column>
						<el-table-column label="状态">
							<template slot-scope="scope">
								<span v-if="scope.row.status == 0">无效</span>
								<span v-if="scope.row.status == 1">有效</span>
							</template>
						</el-table-column>
						<el-table-column label="创建人">
							<template slot-scope="scope">
								<el-tag>{{ scope.row.admin_type_text }}</el-tag>

							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<!-- {{ scope.row.recharge_gear }} -->
								<el-popover placement="left" width="700" :offset="10" trigger="hover"
									v-if="scope.row.w_recharge_gear != null">
									<div style="padding: 0;width: 100%;height: 100%;background-color: #eee;">
									<div class="wai" style="display: flex; margin-left: -15px">
										<div class="PreviewBox" style="align-self: flex-start">
											<div class="btnAdDanjuitem" v-for="(item, index) in scope.row.recharge_gear"
												:key="index" v-if="item.recharge_type == 2">
												<div class="left" v-if="item.description">
													<div class="left_top"
														style="margin-top: 8px;font-size: 20px;font-weight: bold;color: #fff;">
														解锁本剧<span style="color: #f9da63;">全集</span></div>
													<div class="left_btn" style="margin-top: 0px;color: #f7d5dd;">{{
														item.description }}</div>

												</div>
												<div class="left" v-else>
													<div class=""
														style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
														解锁本剧 <span>全集</span></div>

												</div>
												<div class="right">¥<span style="font-weight: bold;">{{ item.money
														}}</span>
												</div>
											</div>
											<div class="btnAd" v-for="(item, index) in scope.row.recharge_gear"
												:key="index" v-if="item.recharge_type == 1 || item.recharge_type == 0">
												<div class="btnAd_wai"
													:class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
													<div class="price">¥ {{ item.money }}</div>
													<div>
														<div style="position: relative" v-if="item.recharge_type == 0">
															<div class="bi">
																{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;"
																	v-if="item.free_balance > 0">+{{ item.free_balance ?
																		item.free_balance : 0 }}k币</span>
															</div>
															<div class="dingBtn" v-if="item.goods_mark_txt"
																style="background-color: #ed6c34">{{ item.goods_mark_txt
																}}</div>
														</div>
														<div v-else style="position: relative">
															<div class="bi">{{ item.description }}</div>
															<div class="dingBtn" v-if="item.goods_mark_txt"
																style="background-color: #ed6c34">{{ item.goods_mark_txt
																}}</div>
														</div>
													</div>

													<div>
														<div class="song" v-if="item.recharge_type == 0"
														style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
															{{ item.footer_mark_txt && item.footer_mark_txt != undefined
																? item.footer_mark_txt : '' }}
														</div>
														<div class="song" style="background-color: #fc5e5d;color: #fff;font-weight: bold;"
															v-else>
															{{ item.footer_mark_txt && item.footer_mark_txt != undefined
																? item.footer_mark_txt : '' }}
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="PreviewBox"
											style="margin-left: 0px; flex-grow: 1; align-self: flex-start">
											<div class="btnAdDanjuitem" v-for="(item, index) in scope.row.w_recharge_gear"
												:key="index" v-if="item.recharge_type == 2">
												<div class="left" v-if="item.description">
													<div class="left_top"
														style="margin-top: 8px;font-size: 20px;font-weight: bold;color: #fff;">
														解锁本剧<span style="color: #f9da63;">全集</span></div>
													<div class="left_btn" style="margin-top: 0px;color: #f7d5dd;">{{
														item.description }}</div>

												</div>
												<div class="left" v-else>
													<div class=""
														style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
														解锁本剧 <span>全集</span></div>

												</div>
												<div class="right">¥<span style="font-weight: bold;">{{ item.money
														}}</span>
												</div>
											</div>
											<div class="btnAd" v-for="(item, index) in scope.row.w_recharge_gear"
												:key="index" v-if="item.recharge_type == 1 || item.recharge_type == 0">
												<div class="btnAd_wai"
													:class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
													<div class="price">¥ {{ item.money }}</div>
													<div>
														<div style="position: relative" v-if="item.recharge_type == 0">
															<div class="bi">
																{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;"
																	v-if="item.free_balance > 0">+{{ item.free_balance ?
																		item.free_balance : 0 }}k币</span>
															</div>
															<div class="dingBtn" v-if="item.goods_mark_txt"
																style="background-color: #ed6c34">{{ item.goods_mark_txt
																}}</div>
														</div>
														<div v-else style="position: relative">
															<div class="bi">{{ item.description }}</div>
															<div class="dingBtn" v-if="item.goods_mark_txt"
																style="background-color: #ed6c34">{{ item.goods_mark_txt
																}}</div>
														</div>
													</div>

													<div>
														<div class="song" v-if="item.recharge_type == 0"
														style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
															{{ item.footer_mark_txt && item.footer_mark_txt != undefined
																? item.footer_mark_txt : '' }}
														</div>
														<div class="song" style="background-color: #fc5e5d;color: #fff;font-weight: bold;"
															v-else>
															{{ item.footer_mark_txt && item.footer_mark_txt != undefined
																? item.footer_mark_txt : '' }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
									<el-link type="primary" slot="reference"
										@mouseover="Preview(scope.row)">预览</el-link>
								</el-popover>
								<el-popover placement="left" width="356" trigger="hover" v-else>
									<div style="padding: 0;width: 100%;height: 100%;background-color: #eee;">
									<div class="wai" style="display: flex; margin-left: -15px">
										<div class="PreviewBox">
											<div class="btnAdDanjuitem" v-for="(item, index) in scope.row.recharge_gear"
												:key="index" v-if="item.recharge_type == 2">
												<div class="left" v-if="item.description">
													<div class="left_top"
														style="margin-top: 8px;font-size: 20px;font-weight: bold;color: #fff;">
														解锁本剧<span style="color: #f9da63;">全集</span></div>
													<div class="left_btn" style="margin-top: 0px;color: #f7d5dd;">{{
														item.description }}</div>

												</div>
												<div class="left" v-else>
													<div class=""
														style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
														解锁本剧 <span>全集</span></div>

												</div>
												<div class="right">¥<span style="font-weight: bold;">{{ item.money
														}}</span>
												</div>
											</div>
											<div class="btnAd" v-for="(item, index) in scope.row.recharge_gear"
												:key="index" v-if="item.recharge_type == 1 || item.recharge_type == 0">
												<div class="btnAd_wai"
													:class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
													<div class="price">¥ {{ item.money }}</div>
													<div>
														<div style="position: relative" v-if="item.recharge_type == 0">
															<div class="bi">
																{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;"
																	v-if="item.free_balance > 0">+{{ item.free_balance ?
																		item.free_balance : 0 }}k币</span>
															</div>
															<div class="dingBtn" v-if="item.goods_mark_txt"
																style="background-color: #ed6c34">{{ item.goods_mark_txt
																}}</div>
														</div>
														<div v-else style="position: relative">
															<div class="bi">{{ item.description }}</div>
															<div class="dingBtn" v-if="item.goods_mark_txt"
																style="background-color: #ed6c34">{{ item.goods_mark_txt
																}}</div>
														</div>
													</div>

													<div>
														<div class="song" v-if="item.recharge_type == 0"
														style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
															{{ item.footer_mark_txt && item.footer_mark_txt != undefined
																? item.footer_mark_txt : '' }}
														</div>
														<div class="song" style="background-color: #fc5e5d;color: #fff;font-weight: bold;"
															v-else>
															{{ item.footer_mark_txt && item.footer_mark_txt != undefined
																? item.footer_mark_txt : '' }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
									<el-link type="primary" slot="reference"
										@mouseover="Preview(scope.row)">预览</el-link>
								</el-popover>
								<el-link type="primary" slot="reference" style="margin-left: 12px;"
									@click="selectHand(scope.row.id)">选择</el-link>
							</template>
						</el-table-column>
					</el-table>
					<pagination v-show="total > 0" :total="total" :page.sync="queryParamsLook.pageNo"
						:limit.sync="queryParamsLook.pageSize" @pagination="getListLook" />
				</div>
			</el-dialog>
		</el-drawer>
	</div>
</template>

<script>
import { channelNumberAPI } from '@/api/popularize/channelNumber';
import { processErrors } from '@/utils/errorHandler';
import { useLoginApi } from '@/api/login';
import { playletAPI } from '@/api/popularize/playletList';
export default {
	props: ['AddFlag', 'tableObj'],
	components: {},
	data() {
		return {
			formLabelWidth: "120px",
			chapter: {
				chapter_priceone: '',
				chapter_pricetwo: '',
				free_chapteroneone: '',
				free_chaptertwo: '',
			},
			queryParamsLook: {
				pageNo: 1,
				pageSize: 10,
			},
			switch_btn: 0,
			addFrom: {
				recharge_template_id: '',
				owner: '',
				status: '',
				channel_name: '',
				ad_id: 0,
				channel_code: '',
				o_chapter_price: '',
				o_free_chapter: '',
			},
			LookVisible: false,
			tableData: [],
			Recharge: [{ id: 0, value: '默认' }],
			RechargeRule: [{ id: 0, title: '默认配置' }],
			rules: {
				recharge_template_id: [{ required: true, message: '请选择充值模版', trigger: 'change' }],
				status: [{ required: true, message: '请选择状态', trigger: 'change' }],
				owner: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
				o_chapter_price: [
					{ required: false, message: '请输入单集价格', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							// 如果没有输入值，直接调用callback，不做任何验证
							if (value === null || value === '') {
								callback();
							} else if (value < this.chapter.chapter_priceone || value > this.chapter.chapter_pricetwo) {
								callback(new Error('单集价格必须在' + this.chapter.chapter_priceone + '和' + this.chapter.chapter_pricetwo + '之间'));
							} else {
								callback(); // 验证通过
							}
						},
						trigger: 'blur',
					},
				],
				o_free_chapter: [
					{ required: false, message: '免费集数范围', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							// 如果没有输入值，直接调用callback，不做任何验证
							if (value === null || value === '') {
								callback();
							} else if (value < this.chapter.free_chapteroneone || value > this.chapter.free_chaptertwo) {
								callback(new Error('免费集数必须在' + this.chapter.free_chapteroneone + '和' + this.chapter.free_chaptertwo + '之间'));
							} else {
								callback(); // 验证通过
							}
						},
						trigger: 'blur',
					},
				],
			},
		};
	},

	methods: {
		Look() {
			this.LookVisible = true;
			this.getListLook();
		},
		getListLook() {
			let api = playletAPI();

			api.RechargeList(this.queryParamsLook).then((res) => {
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.totalCount;
				} else {
					processErrors(res);
				}
			});
		},
		selectHand(id) {
			this.addFrom.recharge_template_id = id
			this.LookVisible = false
		},
		handleCloseLook() {
			this.LookVisible = false;
		},
		getUserinfo() {
			const api = useLoginApi();
			api.getUserinfo().then((res) => {
				this.switch_btn = res.data.chapter_switch;
			});
		},
		AddNone() {
			this.$emit('NoneChannel');
		},
		handleClose() {
			this.$emit('NoneChannel');
		},
		addPush() {

			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let api = channelNumberAPI();
					api.channelAdded(this.addFrom).then((res) => {
						if (res.code == 0) {
							this.$message({
								message: '编辑成功',
								type: 'success',
							});
							this.$emit('NoneChannel');
						} else {
							processErrors(res);
							this.$emit('NoneChannel');
						}
					});
				} else {
					return false;
				}
			});
		},
		SelectRecharge() {
			let api = channelNumberAPI();
			let params = {
				// movie_id:this.tableObj.movie_id,
				pageNo: 1,
				pageSize: 9999
			}
			api.RechargeList(params).then((res) => {
				if (res.code == 0) {
					if (Array.isArray(res.data.data) && res.data.data.length === 0) {
						let obj = {
							value: '默认充值模版',
							id: '',
						};
						this.Recharge.push(obj);
					} else {
						this.Recharge = res.data.data.map((item) => {
							return {
								value: 'ID=' + item.id + '，标题=' + item.name + '，创建人=' + item.admin_type_text,
								id: item.id,
							};
						});
						this.Recharge.unshift({ id: 0, value: '默认充值模版' });
					}
				} else {
					processErrors(res);
				}
			});
		},
		SelectRechargeRule() {
			let api = channelNumberAPI();
			api.Adselect(this.tableObj.media).then((res) => {
				this.RechargeRule = res.data;
				let objs = {
					title: '默认配置',
					id: 0,
				};
				this.RechargeRule.unshift(objs);
				const selectedRule = this.RechargeRule.find((item) => item.id == this.addFrom.ad_id);
			});
		},
	},
	created() {
		this.getUserinfo();
	},
	mounted() {
		let api = playletAPI();
		// 		api.detailsList(this.tableObj.movie_id).then((res=>{
		// 			this.tableObj=res.data
		// 			this.addFrom.recharge_template_id = res.data.recharge_template_id;
		// 		this.addFrom.owner = this.tableObj.owner;
		// 		this.addFrom.status = this.tableObj.status;
		// 		this.addFrom.channel_name = this.tableObj.channel_name;
		// 		this.addFrom.channel_code = this.tableObj.channel_code;
		// 		this.addFrom.ad_id = this.tableObj.ad_id;
		// 		this.addFrom.o_chapter_price = this.tableObj.o_chapter_price == 0 ? '' : this.tableObj.o_chapter_price;
		// this.addFrom.o_free_chapter = this.tableObj.o_free_chapter == 0 ? '' : this.tableObj.o_free_chapter;
		// 		}))

		// api.freepoint(this.tableObj.novel_id).then((res) => {
		// 	if (res.code == 0) {
		// 		this.chapter.chapter_priceone = res.data.chapter_price_range[0];
		// 		this.chapter.chapter_pricetwo = res.data.chapter_price_range[1];
		// 		this.chapter.free_chapteroneone = res.data.free_chapter_range[0];
		// 		this.chapter.free_chaptertwo = res.data.free_chapter_range[1];
		// 	} else {
		// 		processErrors(res);
		// 	}
		// });
		this.SelectRecharge();
		this.SelectRechargeRule();
		this.addFrom.recharge_template_id = this.tableObj.recharge_template_id;
		this.addFrom.owner = this.tableObj.owner;
		this.addFrom.status = this.tableObj.status;
		this.addFrom.channel_name = this.tableObj.channel_name;
		this.addFrom.channel_code = this.tableObj.channel_code;
		this.addFrom.ad_id = this.tableObj.ad_id;
		this.addFrom.o_chapter_price = this.tableObj.o_chapter_price == 0 ? '' : this.tableObj.o_chapter_price;
		this.addFrom.o_free_chapter = this.tableObj.o_free_chapter == 0 ? '' : this.tableObj.o_free_chapter;
		// const selectedRule= this.RechargeRule.find(item => item.id == this.tableObj.ad_id);
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep el-card__body {
		padding: 0 !important;
	}
}

.btnAdDanjuitem {
	padding: 0;
	display: flex;
	margin-left: 16px;
	background-image: url('../../../../assets/微信图片_20240910174026.png');
	background-size: cover;
	// /* 使背景图覆盖整个容器 */
	background-position: center;
	// /* 背景图居中对齐 */
	background-repeat: no-repeat;
	/* 背景图不重复 */
	// height: 100vh;
	/* 高度覆盖视口高度 */
	width: 314px;
	margin-bottom: 20px;
	height: 70px;
	border: #ccc 1px solid;
	border-radius: 10px;
	position: relative;
	overflow: hidden;

	.left {
		// display: flex;
		// flex-direction: column;
		width: 230px;
		// height: 80px;
		// line-height: 70px;
		text-align: center;
		// line-height: 30px;
	}

	.right {
		width: 100px;
		line-height: 70px;
		text-align: center;
		color: #e44663;

		span {
			font-size: 18px;
			color: #e44663;
			text-align: center;
		}
	}

	.right_jiao {
		height: 10px;
		position: absolute;
		right: 0px;

		top: -20px;
		// width: 40px;
		font-size: 11px;

		.jiao {
			color: #fff;
			margin-top: 9px;
			padding: 2px 10px 2px 16px;
			background-color: #ed6e33;
			// width: 80px;
			text-align: center;
			height: 30px;
			border-bottom-left-radius: 20px;
		}
	}
}

.center-content {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}

.PreviewBox {
	width: 800px;
	// height: 300px;
	display: flex;
	// justify-content: space-around;
	flex-wrap: wrap;
	padding: 4px;

	.white-background {
		background-color: #fff;
	}

	.black-background {

		background-color: white;
		background-image: url('../../../../assets/zhuan.png');
		background-size: cover;
		/* 使背景图覆盖整个容器 */
		background-position: center;
		/* 背景图居中对齐 */
		background-repeat: no-repeat;
		//  背景图不重复
		height: 100vh;
	}

	.btnAd {
		width: 150px;
		height: 110px;
		// border: #ccc 1px solid;
		border-radius: 10px;
		// margin-top: 10px;
		padding: 0px;
		margin-left: 16px;

		.btnAd_wai {
			border-radius: 10px;
			width: 150px;
			height: 100px;

			.price {
				height: 20px;
				font-size: 15px;
				line-height: 60px;
				text-align: center;
				font-size: 18px;
				font-weight: bold;
			}

			.bi {
				font-size: 10px;
				margin-top: 23px;
				// margin-top: 6px;
				text-align: center;
			}

			.dingBtn {
				position: absolute;
				top: -43px;
				right: 0px;
				height: 20px;
				// width: 40px;
				background-color: antiquewhite;
				line-height: 18px;
				text-align: center;
				padding: 2px 6px;
				background-color: #1890ff;
				color: #fff;
				border: 1px solid #ed6e33;
				border-top-right-radius: 7px;
				border-bottom-left-radius: 10px;
				font-size: 11px;
			}

			.song {
				margin: auto;
				width: 100%;
				line-height: 29px;
				text-align: center;
				font-size: 13px;
				margin-top: 15px;
				background-color: #1890ff;
				// border-radius: 10px;
				color: #fff;
				border-bottom-left-radius: 10px;
				border-bottom-right-radius: 10px;
			}
		}
	}
}

.center-content .el-col {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.demo-drawer__content {
	height: calc(100% - 80px);
	/* 给内容区域设置高度,留出按钮区域 */
	overflow-y: auto;
	/* 添加垂直滚动条 */
	overflow-x: hidden;
}

.form-wrapper {
	padding-bottom: 80px;
	/* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 10px;
	text-align: center;
}

.demo-drawer__footer .el-button {
	margin: 0 10px;
	width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
	font-size: 30px;
	font-weight: bold;
}
</style>
